var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-suggestion" },
    [
      _vm._t("label", function () {
        return [
          _vm.label || _vm.$t("suggestable_models." + this.model)
            ? _c(
                "div",
                {
                  class:
                    "label-div text-sm " + (_vm.focused ? "text-primary" : ""),
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.label || _vm.$t("suggestable_models." + this.model)
                      )
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      }),
      _c(
        "div",
        { staticClass: "flex flex-row gap-2 w-full" },
        [
          _c(
            "div",
            { staticClass: "min-h-full w-full relative" },
            [
              _c(
                "vs-select",
                {
                  ref: "select",
                  staticClass: "w-full",
                  attrs: {
                    autocomplete: "",
                    placeholder: _vm.translatedPlaceholderText,
                    danger: _vm.selectedModel === undefined,
                    "danger-text": "Seleção inválida",
                    noData: _vm.noData,
                    disabled: _vm.isDisabled,
                  },
                  on: {
                    "input-change": _vm.searchSuggestions,
                    input: _vm.selectModel,
                    focus: _vm.onFocus,
                    blur: function ($event) {
                      _vm.focused = false
                    },
                  },
                  model: {
                    value: _vm.selectedModelId,
                    callback: function ($$v) {
                      _vm.selectedModelId = $$v
                    },
                    expression: "selectedModelId",
                  },
                },
                _vm._l(_vm.suggestedModels, function (model) {
                  return _c("vs-select-item", {
                    key: model.id,
                    attrs: { value: model.id, text: _vm.itemTextFormat(model) },
                  })
                }),
                1
              ),
              _c("div", {
                staticClass:
                  "loadingContainer absolute inset-0 pointer-events-none p-3 pr-6 flex items-center justify-end",
              }),
            ],
            1
          ),
          _vm.selectedModelId && _vm.appendClearOption && !_vm.isDisabled
            ? _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.auto",
                      value: {
                        content: "Limpar seleção",
                        delay: { show: 1000, hide: 100 },
                      },
                      expression:
                        "{\n          content: 'Limpar seleção',\n          delay: { show: 1000, hide: 100 },\n        }",
                      modifiers: { auto: true },
                    },
                  ],
                  staticClass: "flex-grow-0 flex-shrink-0 h-auto btn-icon",
                  attrs: { variant: "outline-danger" },
                  on: { click: _vm.clearSelection },
                },
                [
                  _c("feather-icon", {
                    staticClass: "text-danger stroke-current",
                    attrs: { icon: "XIcon" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }